module.exports = __webpack_public_path__ + "img/lab.403693c5.svg";